import { render, staticRenderFns } from "./Accommodations.vue?vue&type=template&id=284a1c4a"
import script from "./Accommodations.vue?vue&type=script&lang=js"
export * from "./Accommodations.vue?vue&type=script&lang=js"
import style0 from "./Accommodations.vue?vue&type=style&index=0&id=284a1c4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports